// 入口修订号用于绕开历史 public 文件的 HTTP/CDN 缓存；普通 SDK 升级仍由 SW 更新机制处理。
// Emarsys 内部会补根斜杠，两端必须使用这里的同一个地址。
export const SITE_SERVICE_WORKER_RELATIVE_URL = 'service-worker.js?v=sdk-resources-v1';
export const SITE_SERVICE_WORKER_SCRIPT_URL = `/${SITE_SERVICE_WORKER_RELATIVE_URL}`;
export const SITE_SERVICE_WORKER_SCOPE = '/';
